import awardPrice from "assets/awardPrice1.png";
import contract from "assets/contract.svg";
import mobileImageBottom from "assets/image copy 2.png";
import mobileImageTop from "assets/image copy 3.png";
import desktopImage from "assets/image.png";
import lines from "assets/lines.svg";
import React from "react";
import { Helmet } from "react-helmet";

const Awards = () => {
  return (
    <div className="mt-[93px] z-0">
      <Helmet>
        <title>Megaball | Шагналын сан</title>
      </Helmet>
      <div className="flex bg-[#0048A6] justify-center relative z-0 overflow-hidden h-[100px] items-center">
        <p className="font-bold text-4xl text-black0 text-center md:text-[32px]">
          Шагналын сан
        </p>
        <img
          alt=""
          src={lines}
          className="object-cover absolute right-0 bottom-0 pointer-events-none"
        />
      </div>

      <div className="bg-black10 py-16 relative flex justify-center">
        <div className="flex md:flex-col">
          <div className="hidden md:block">
            <p className="text-center text-xl text-black70 font-bold">
              Хонжворын дүн
            </p>
          </div>

          <div className="flex flex-col justify-center relative pt-8">
            <div className="flex-row flex">
              <div>
                <div className="flex flex-row justify-around flex-1 mb-2"></div>

                {/* Desktop */}
                <img
                  alt=""
                  src={desktopImage}
                  className="relative z-10 pointer-events-none max-w-[900px] w-full md:hidden"
                />

                {/* Mobile */}
                <div className="hidden md:block relative w-full px-4">
                  <img
                    alt=""
                    src={mobileImageTop}
                    className=" pointer-events-none w-full"
                  />
                  <img
                    alt=""
                    src={mobileImageBottom}
                    className=" pointer-events-none w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          alt=""
          src={contract}
          className="absolute pointer-events-none z-0 left-0 top-0 md:hidden"
        />
      </div>
    </div>
  );
};

export default Awards;
